module.exports = __webpack_public_path__ + "media/country_flags/ru-fba4c5ac.png";